import React from "react";

function clampRating(value) {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isInteger(parsed)) {
    return 0;
  }

  return Math.max(0, Math.min(5, parsed));
}

function buildStars(rating) {
  if (rating < 1) {
    return "Sin calificacion";
  }

  return `${"★".repeat(rating)}${"☆".repeat(5 - rating)}`;
}

export default function ApprovedOpinionList({ opinions = [] }) {
  const hasOpinions = opinions.length > 0;

  return (
    <section className="panel approved-opinion-list" aria-label="Opiniones publicadas">
      <div className="approved-opinion-list-copy">
        <span className="eyebrow">Opiniones</span>
        <h2>Opiniones publicadas</h2>
      </div>

      {hasOpinions ? (
        <div className="approved-opinion-cards">
          {opinions.map((opinion, index) => {
            const rating = clampRating(opinion?.rating);
            const key = opinion?.id || opinion?.published_at || `${opinion?.reviewer_name || "opinion"}-${index}`;

            return (
              <article className="approved-opinion-card" data-testid="approved-opinion-card" key={key}>
                <div className="approved-opinion-rating">
                  <strong>{opinion?.reviewer_name || "Opinion anonima"}</strong>
                  <span className="approved-opinion-rating-row">
                    <span className="approved-opinion-rating-value">{rating}/5</span>
                    <span aria-label={`${rating} de 5 estrellas`}>{buildStars(rating)}</span>
                  </span>
                </div>
                <p>{opinion?.comment || ""}</p>
              </article>
            );
          })}
        </div>
      ) : (
        <p className="approved-opinion-empty">Todavia no hay opiniones publicadas.</p>
      )}
    </section>
  );
}
